import {defaultPostData, getCurrentUser} from "./utils/common";
import {EventType} from "./events";
import {showToast} from "./toast";
import {Timer} from "../../types/frontend/js/timer/timer";
import {VisibleStatus} from "./utils/consts";
import customSelect from "./customSelect";

// TODO: Перенести в модуль task-edit

type ServerUserData = {avatar: string, name: string};
type ClientUserData = {img: string, name: string};
type State = {currentValue: string};
type Response = {
  status: number, answer: {
    currentUser: ServerUserData;
    newUser: ServerUserData;
    currentAuthor: ServerUserData;
    newAuthor: ServerUserData;
    subscribers?: unknown[];
  }
}
type Options = {
  user: {
    name: string;
    img: string;
    fullName: string;
    email: string;
  };
  oldResponsible?: ClientUserData;
  newResponsible?: ClientUserData;
  currentAuthor?: ClientUserData;
  newAuthor?: ClientUserData;
}

export const changeUser = (timer: Timer) => {
  const changeUserFormsElements = document.querySelectorAll(`.js-change-user-form`);
  const changeResponsibleModalElement = document.querySelector(`.js-change-responsible`)!;

  const InputName = {
    CREATOR: `Task[user_create_id]`,
    RESPONSIBLE: `Task[user_assigned_id]`,
  };

  if (changeUserFormsElements.length) {
    // const closeModalElement: HTMLButtonElement = changeResponsibleModalElement.querySelector(`.js-close`)!;
    const confirmChangeElement: HTMLButtonElement = changeResponsibleModalElement.querySelector(`.js-confirm`)!;
    const discardChangeElement: HTMLButtonElement = changeResponsibleModalElement.querySelector(`.js-discard`)!;

    const isShowChangeModal = Boolean(document.querySelector(`[data-self-sub="change"]`));

    const activateCreatorSelect = () => {
      // @ts-ignore
      customSelect({
        selectSelector: `.js-creator-select`,
        inputSelector: `.js-responsible-show`,
        openClass: `modal--show`,
        activeItemClass: `modal__item--active`,
        isResponsibleSelect: true,
      });
    };

    const convertUserDataFromServer = (data: ServerUserData): ClientUserData => {
      return {
        name: data.name,
        img: data.avatar,
      };
    };

    const setActivityStatusResponsibleModal = (status: `SHOW` | `HIDE`) => {
      if (changeResponsibleModalElement) {
        switch (status) {
          case VisibleStatus.SHOW:
            changeResponsibleModalElement.classList.add(`one-task__delete-modal--show`);
            break;
          case VisibleStatus.HIDE:
            changeResponsibleModalElement.classList.remove(`one-task__delete-modal--show`);
            break;
        }
      }
    };

    const sendNewUser = async (input: HTMLInputElement, state: State, isSelfSubscribeType?: boolean) => {
      const form = input.form!;

      state.currentValue = input.value;
      const data = new FormData(form);

      if (isSelfSubscribeType !== undefined) {
        data.set(`remainSubscriber`, `${isSelfSubscribeType ? `add` : `delete`}`);
      }

      const url = form.action;

      const result: Response = await defaultPostData(data, url);

      if (result.status === 200) {
        if (timer) {
          timer.updateTimer();
        }

        const options: Options = {
          user: getCurrentUser(),
        };

        let type: string = ``;

        if (result.answer.currentUser) {
          type = EventType.RESPONSIBLE;

          options.oldResponsible = convertUserDataFromServer(result.answer.currentUser);
          options.newResponsible = convertUserDataFromServer(result.answer.newUser);

        } else if (result.answer.currentAuthor) {
          type = EventType.AUTHOR;

          options.currentAuthor = convertUserDataFromServer(result.answer.currentAuthor);
          options.newAuthor = convertUserDataFromServer(result.answer.newAuthor);
        }

        window.taskEmitter.emit(`events.render`, type, options);
        if (result.answer.subscribers?.length) {
          window.taskEmitter.emit(`subscribers.update`, result.answer.subscribers);
        }
      } else {
        showToast(`Ошибка отправки запроса`);
      }
    };

    const activateSendUser = async (evt: Event, state: State, form: HTMLFormElement) => {

      const self = evt.target! as HTMLInputElement;
      const newValue = (self as HTMLInputElement).value;

      const isGuestUser = Boolean(form.dataset.userType === `guest`);

      if (state.currentValue !== newValue) {
        if (self.name === InputName.RESPONSIBLE && isGuestUser && isShowChangeModal) {
          setActivityStatusResponsibleModal(VisibleStatus.SHOW);
          addModalEvents(self, state);
        } else if (self.name === InputName.CREATOR || !isGuestUser || !isShowChangeModal) {
          await sendNewUser(self, state);
        }
      }
    };

    const addModalEvents = (input: HTMLInputElement, state: State) => {
      const removeEvents = () => {
        confirmChangeElement.removeEventListener(`click`, onConfirmElementClick);
        discardChangeElement.removeEventListener(`click`, onDiscardElementClick);
        // closeModalElement.removeEventListener(`click`, onCloseModalClick);
      };

      const onConfirmElementClick = async () => {
        await sendNewUser(input, state, true);
        setActivityStatusResponsibleModal(`HIDE`);

        removeEvents();
      };

      const onDiscardElementClick = async () => {
        await sendNewUser(input, state, false);
        setActivityStatusResponsibleModal(`HIDE`);

        removeEvents();
      };

      confirmChangeElement.addEventListener(`click`, onConfirmElementClick, {once: true});
      discardChangeElement.addEventListener(`click`, onDiscardElementClick, {once: true});
      // closeModalElement.addEventListener(`click`, onCloseModalClick, {once: true});
    };

    changeUserFormsElements.forEach((changeUserFormElement: HTMLFormElement) => {
      const accessType = changeUserFormElement.dataset.userType;
      const hiddenInputs: NodeListOf<HTMLInputElement> = changeUserFormElement.querySelectorAll(`.js-select-h-input`);

      if (accessType === `admin`) {
        activateCreatorSelect();
      }

      hiddenInputs.forEach((hiddenInput) => {
        const state: {currentValue: string} = {
          currentValue: hiddenInput.value,
        };

        const onUserInputChange = async (evt: Event) => {
          await activateSendUser(evt, state, changeUserFormElement);
        };

        hiddenInput.addEventListener(`change`, onUserInputChange);
      });
    });
  }
};
